/* eslint-disable import/prefer-default-export */
import styled from 'styled-components';

export const StyledWrapperProgressBar = styled.article`
  display: flex;
  align-items: center;
  margin-left: 8px;
  flex: 1 0 auto;
  && > div > div {
    margin: 0px;
  }
  & > div > div:nth-child(2) {
    height: 3px;
  }
  & [data-progress='0'] {
    min-width: 0px !important;
  }
  & .text-name-step {
    color: #f42534 !important;
    font-size: 14px;
  }
`;

export const StyledWrapperStepper = styled.section`
  margin-bottom: 24px;
  @media screen and (min-width: 768px) {
    margin-bottom: 0px;
  }
  && span {
    font-size: 14px;
  }
`;
